import { render } from "./selectOldDateModel.vue?vue&type=template&id=a224ede8"
import script from "./selectOldDateModel.vue?vue&type=script&lang=js"
export * from "./selectOldDateModel.vue?vue&type=script&lang=js"

import "./selectOldDateModel.vue?vue&type=style&index=0&id=a224ede8&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__